import { AuthPage } from './AuthPage';

export function SignupPage() {
  return <AuthPage mode="signup" />;
}
